module.exports = __webpack_public_path__ + "img/mockup_benefit2@2x.977cd701.png";